import { render, staticRenderFns } from "./awardContent.vue?vue&type=template&id=7aed595b&scoped=true&"
import script from "./awardContent.vue?vue&type=script&lang=ts&"
export * from "./awardContent.vue?vue&type=script&lang=ts&"
import style0 from "./awardContent.vue?vue&type=style&index=0&id=7aed595b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed595b",
  null
  
)

export default component.exports